import { render, staticRenderFns } from "./index copy 2.vue?vue&type=template&id=fd212874&scoped=true&"
import script from "./index copy 2.vue?vue&type=script&lang=js&"
export * from "./index copy 2.vue?vue&type=script&lang=js&"
import style0 from "./index copy 2.vue?vue&type=style&index=0&id=fd212874&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd212874",
  null
  
)

export default component.exports